var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1446_12638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 27H33V9H3V27ZM32.0621 26.1H3.93787V9.9H32.0739L32.0621 26.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6773 20.4728H9.06805V13.7368H6.87085V22.2632H12.6773V20.4728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4192 18.605V17.395C20.4192 15.1058 19.1527 13.7368 17.0321 13.7368C14.9115 13.7368 13.645 15.1058 13.645 17.395V18.605C13.645 20.8942 14.9115 22.2632 17.0321 22.2632C19.1527 22.2632 20.4192 20.8942 20.4192 18.605ZM17.0321 20.5363C16.2133 20.5363 15.8422 19.9228 15.8422 18.5822V17.4178C15.8422 16.0772 16.2133 15.4637 17.0321 15.4637C17.8509 15.4637 18.222 16.0772 18.222 17.4178V18.5822C18.222 19.9228 17.8509 20.5363 17.0321 20.5363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4814 22.2632V15.4799H29.1289V13.7368H21.387V15.4799H24.0345V22.2632H26.4814Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1446_12638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 18,
    fill: "white",
    transform: "translate(3 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLot);
export default __webpack_public_path__ + "static/media/lot.db38a7672027e0a07834d96b32c01a58.svg";
export { ForwardRef as ReactComponent };